import { Field, FieldError, Label } from "@/components/ui";
import { Textarea } from "@/components/ui/Textarea/Textarea";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { SubmitCancelButtons } from "../../components/SubmitCancelButtons";

interface MiscellaneousNoteFormProps {
  noteId?: string;
  text?: string;
  onSubmit: (data: z.infer<typeof formSchema>) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

const formSchema = z.object({
  text: z.string().min(1, "Note text is required"),
});

export const MiscellaneousNoteForm = ({
  noteId,
  text,
  onSubmit,
  onCancel,
  isSubmitting,
}: MiscellaneousNoteFormProps) => {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      text: text || "",
    },
  });

  return (
    <div>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-2 px-3 py-2"
      >
        {!noteId && <Label>Add Miscellaneous Note</Label>}
        <Controller
          control={form.control}
          name="text"
          render={({ field, fieldState }) => (
            <Field>
              <Textarea {...field} placeholder="Enter note" rows={3} />
              <FieldError errors={[fieldState.error]} />
            </Field>
          )}
        />
        <SubmitCancelButtons isSaving={isSubmitting} onCancel={onCancel} />
      </form>
    </div>
  );
};
